
import { defineComponent, ref, reactive, onMounted } from 'vue'
import { useStore } from 'vuex'


export default defineComponent({

    props: {
        visible: {
            type: Boolean,
            default: true,
        },
        title: {
            type: String,
            default: 'Create Role',
        },
        data: {
            type: Object,
        },
    },

    setup(props) 
    {
        const form = ref<any>(props.data);
        const name = ref('Role')
        const store = useStore()


        return {
            form,
            name,
        }
    }
})
